// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-265fc19d5d65215c.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	if (chunkId === 3850) return "static/chunks/3850-69678ef8a2030b20.js";
	if (chunkId === 19) return "static/chunks/19-1f939d587444f697.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"932":"e8171a240b7e7a74","1475":"058725ae42d20765","2231":"6bdbf463fdd30080","4176":"669c4741153eddb4","6329":"e59ea02bc211f25b","6690":"dd883f4b06950a4f","7794":"684730782c24c8c2"}[chunkId] + ".js";
};